// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';

// Components
import StateScreen from './StateScreen';

/**
 * @function Loading
 * Describe the component's function
 *
 * @example
 * return (
 *   <Loading text='' />
 * )
 */
function Loading({ text }: LoadingProps): JSX.Element {
    return (
        <StateScreen
            icon={<FontAwesomeIcon icon={faSpinnerThird} spin />}
            title={text}
        />
    );
}

/**
 * @interface LoadingProps
 * Describes the properties required for the Loading component
 *
 * @property {string} text Current position in draw sequence
 */
export interface LoadingProps {
    text: string;
}

// Exports
export default Loading;
